/**
 * 导航，控制webview
 */
import {supportNative, getErrorFactory, logError} from './util';
import qs from 'qs';
import _url from '../utils/url';
import existApp from './existApp';
import {
  downloadTanTuMap as downloadTanTuMapUrl,
  downloadTanTuTravel as downloadTanTuTravelUrl
} from '../config';
import Detector from '../utils/detector';



const history = window.history;
const location = window.location;
const zzc = window.zzc;


const WEBVIEW_STYLES = [
  ['NoWebviewSlide'],
  ['topBar_Remove','webviewStart_StatusBar','NoWebviewSlide'],
  ['topBar_Hidden'],
  ['topBar_Remove','webviewStart_Zero','NoWebviewSlide'],
  ['topBar_Remove','NoWebviewSlide'],
];

// 配置webview
const WEBVIEW_CONFIG = {
  'trip-create': WEBVIEW_STYLES[0],
  'trip-create-cities': WEBVIEW_STYLES[1],
  'trip-create-cities-search': WEBVIEW_STYLES[1],
  'trip-create-cities-additional': WEBVIEW_STYLES[1],
  'trip-create-cities-search-additional': WEBVIEW_STYLES[1],
  'trip-create-date': WEBVIEW_STYLES[1],
  'trip-create-preference': WEBVIEW_STYLES[1],

  'trip-edit': WEBVIEW_STYLES[1],
  'trip-edit-pois': WEBVIEW_STYLES[1],
  'trip-modify-pois': WEBVIEW_STYLES[1],
  'poi2': WEBVIEW_STYLES[1],
  'trip-create-optimization': WEBVIEW_STYLES[1],
  'trip-edit2': WEBVIEW_STYLES[1],
  'trip-edit-days': WEBVIEW_STYLES[1],
  'trip-edit-cities': WEBVIEW_STYLES[1],
  'trip-edit-cities-search': WEBVIEW_STYLES[1],
  'trip-edit-collect': WEBVIEW_STYLES[1],

  'poi': WEBVIEW_STYLES[1],
  'trip-edit-poi': WEBVIEW_STYLES[1],
  'trip-modify-poi': WEBVIEW_STYLES[1],
  'trip-modify-hotel': WEBVIEW_STYLES[1],
  'trip-modify-customhotel': WEBVIEW_STYLES[1],
  'trip-edit-hotel': WEBVIEW_STYLES[1],

  'ask-road-card': WEBVIEW_STYLES[3],
  
  'trip-modify-create-custompoi': WEBVIEW_STYLES[1],
  'trip-edit-create-custompoi': WEBVIEW_STYLES[1],
  'trip-modify-create-customhotel': WEBVIEW_STYLES[1],
  'trip-edit-create-customhotel': WEBVIEW_STYLES[1],
  'trip-edit-customhotel': WEBVIEW_STYLES[1],
  'trip-edit-custompoi': WEBVIEW_STYLES[1],
  'custompoi': WEBVIEW_STYLES[1],
  'create-custompoi': WEBVIEW_STYLES[1],

};

/**
 * 打开一个新页面push
 * **整个项目都必须用这个接口打开URL**
 *
 * @export
 * @param {string} url
 * @param {object} query 查询参数
 */
export function push(url, queryObj = {}, isReplace = false) {
  // 合并url的query和queryObj
  let query = qs.stringify(queryObj);
  url += url.indexOf('?') > -1? `&${query}` : `?${query}`;
  let urlObj = _url.parse(url);
  queryObj = qs.parse(urlObj.query);

  // 添加webview配置
  let config = WEBVIEW_CONFIG[queryObj.page];
  if (config) {
    queryObj.ZZCAppArg = config.join(',');
    if(isReplace){
      queryObj.ZZCAppArg +=',SelfOpenPage';
    }
  }

  // 本项目内URL，将m和page意外参数放到hash
  if (queryObj.m === 'render2' && queryObj.page) {
    let {m, page, ...rest} = queryObj;
    let hash = qs.stringify(rest);

    queryObj = {m, page};
    if (urlObj.hash) {
      urlObj.hash = urlObj.hash + `&${hash}`;
    } else {
      urlObj.hash = `#${hash}`;
    }
  }

  urlObj.query = qs.stringify(queryObj);
  urlObj.search = `?${urlObj.query}`;
  url = _url.format(urlObj);

  if(isReplace){
    location.replace(url);
  }else{
    location.href = url;
  }
}


/**
 * 重新渲染（加载）当前webview
 *
 * @export
 */
export function reload() {
  location.reload();
}


/**
 * 后退n（step）个页面（webview）
 *
 * @export
 * @param {number} [step=1] 后退多少步？ 负数会被转为正数
 * @returns Promise.resolve(true);
 */
export function back(step = 1) {
  step = Math.abs(step);

  if (supportNative('base_goBackPage')) {
    zzc.call('base_goBackPage', {
      step: -step,
      complete: function (res) {
        if (res.state) {
          let errorFactory = getErrorFactory('navigator.back');
          let err = errorFactory(res.message);
          logError(err);
        }
      }
    });
  } else {
    history.back(step);
  }
}


/**
 * 返回首页
 *
 * @export
 * @param {string} [tabName='trip'] APP其中一个tabBar名称
 * * home: 首页
 * * trip: 行程
 * * book: 租车
 * * profile: 我的
 * @returns Promise.resolve(true);
 */
export function backHome(tabName = 'trip') {
  let errorFactory = getErrorFactory('navigator.backHome');

  if (supportNative('base_backToHome')) {
    zzc.call('base_backToHome', {
      tabIndex: tabName,
      complete: function (res) {
        if (res.state) {
          let err = errorFactory(res.message);
          logError(err);
        }
      }
    });
  } else {
    logError(errorFactory('还没实现'));
  }
}


export function removeBackButton() {
  let errorFactory = getErrorFactory('navigator.removeBackButton');

  if (supportNative('base_setTopBackBtnState')) {
    zzc.call('base_setTopBackBtnState', {
      state: 'remove',
      complete: function (res) {
        if (res.state) {
          let err = errorFactory(res.message);
          logError(err);
        }
      }
    });
  } else {
    logError(errorFactory('还没实现'));
  }
}


export function setFadein(startOffset = 0, endOffset = 100) {
  let errorFactory = getErrorFactory('navigator.setFadein');

  if (supportNative('base_setTopNavbarFadeIn')) {
    zzc.call('base_setTopNavbarFadeIn', {
      startOffset: startOffset,
      endOffset: endOffset,
      complete: function (res) {
        if (res.state) {
          let err = errorFactory(res.message);
          logError(err);
        }
      }
    });
  } else {
    logError(errorFactory('还没实现'));
  }
}

// 唤醒APP
export function invoke(url = downloadTanTuTravelUrl) {
  // 默认加上协议
  if ((/^\/\//i).test(url)) {
    url = location.protocol + url;
  } else if ((/^\//i).test(url)) {
    url = location.origin + url;
  }

  if (Detector.os.name === 'android') {
    url = window.encodeURIComponent(url);
    push(`tantutravel://web/${url}`);
  } else {
    push('//oia.tantu.com/redirect.php', {ref: url});
  }
}


/**
 * 探途离线地图
 *
 */

export function tanTuMap(poi) {
  let info = poi.info || {};
  let type = poi.poi_type;
  let map = {
    poi_store: 'store'
  };
  // 修正
  type = map[type] || type;


  existApp('tantu').then(function (val) {
    if (val) {
      push('tantumap://map', {
        lat: info.lat,
        lng: info.lng,
        zoom: 14,
        cn_name: info.cn_name,
        en_name: info.en_name,
        id: info.poi_id,
        data_type: type,
        tags: '',
        ZZCAppArg: ''
      });
    } else {
      downloadTanTuMap();
    }
  }).catch(function () {
    downloadTanTuMap();
  });
}

export function downloadTanTuMap() {
  push(downloadTanTuMapUrl);
}



// WEBPACK FOOTER //
// ./src/native/navigator.js